import * as Auth from 'app/api/auth';
import { pending, rejected, fulfilled } from './async';
import { replace } from 'react-router-redux';

export function login(email, password) {
    return dispatch => {
        dispatch(pending('LOGIN'));
        Auth.login(email, password)
            .then(payload => {
                dispatch(fulfilled('LOGIN', payload));
                // goto the home after login
                dispatch(replace('/'));
            })
            .catch(err => dispatch(rejected('LOGIN', err)));
    };
}

export function loginWithToken(token) {
    return dispatch => {
        dispatch(pending('LOGIN_TOKEN'));
        Auth.loginWithToken(token)
            .then(payload => dispatch(fulfilled('LOGIN_TOKEN', payload)))
            .catch(err => dispatch(rejected('LOGIN', err)));
    };
}

export function clearAndRedirect(dispatch) {
    dispatch(fulfilled('LOGOUT'));
    dispatch({ type: 'RESET' });
}

export function logout() {
    return dispatch => {
        dispatch(pending('LOGOUT'));
        Auth.logout()
            .then(_ => clearAndRedirect(dispatch))
            .catch(err => dispatch(rejected('LOGOUT', err)));
    };
}
